import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from 'PhishingManager/components/Modal';
import { useDashboardContext } from 'Pages/Dashboard/DashboardContext';
import { FEATURE_TYPE } from 'FeatureManager/FeatureManager.type';
import { updateTenantFeature } from 'FeatureManager/FeatureManager.service';
import { errorMessageHandler } from 'PhishingManager/utils';

type Props = { 
    modalData: FEATURE_TYPE, 
    selectedTenant: { label: string, value: number }, 
    getUpdatedData: (features: FEATURE_TYPE[]) => void,
    hideModal: () => void
}

function ConfirmModal({ modalData, selectedTenant, getUpdatedData, hideModal } : Props) {
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();
	const { setToastInfo } = useDashboardContext();
	const intended = !modalData.isEnabled;
    const PATH = `featureManager.modal.${intended ? "enable" : "disable"}`;

	const onSubmit = async () => {
		try {
			setLoading(true);
			const response = await updateTenantFeature(selectedTenant.value, { featureId: modalData.featureId, isEnabled: intended });
			getUpdatedData(response?.features || []);
			setToastInfo?.({ type: "success", message: t(`${PATH}Success`), icon: "check" })
		} catch (error) {
			const toastMessage = errorMessageHandler(error, 'errorCodes.genericErrorMessage');
			setToastInfo?.({ type: "warning", message: t(toastMessage) })
		} finally {
			setLoading(false);
			hideModal();
		}
	};

	return (
		<CommonModal
			visible
			confirmBtnDisabled={loading}
			modalTitle={t(`${PATH}Title`)}
			confirmText={t(`${PATH}Title`)}
			cancelText={t('cancel')}
			iconType={null}
			showConfirmBtn={true}
			onClose={hideModal}
			onConfirm={onSubmit}
			parentClass='feature-confirmation-modal'>
            <p>{t(`${PATH}Description1`)} <strong>{modalData.featureName}?</strong></p>
            <p>{t(`${PATH}Description2`)} <strong>"{selectedTenant.label}"</strong></p>
        </CommonModal>
	);
}

export default ConfirmModal;
